import React from "react";
import { Award, Car, UserCheck, BadgeIndianRupee } from "lucide-react";
import { FEATURES } from "../mock";

const ICONS = [Award, Car, UserCheck, BadgeIndianRupee];

const About = () => {
  return (
    <section id="about" className="py-20 bg-[#fffaf3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://mallikarjunatoursandtravels.in/wp-content/uploads/2023/10/mallikarjuna-swamy-temple.jpg.webp"
              alt="Mallikarjuna Temple"
              className="rounded-3xl shadow-2xl w-full h-[420px] object-cover"
            />
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-white rounded-2xl shadow-xl px-6 py-4 border border-amber-100">
              <div className="font-display text-3xl text-orange-700">10+</div>
              <div className="text-xs text-stone-500 tracking-wide">
                Years of Trust
              </div>
            </div>
          </div>

          <div>
            <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
              Who We Are
            </span>
            <h2 className="font-display text-3xl sm:text-4xl text-orange-900 mt-2 mb-5">
              Welcome To Mallikarjuna Tours &amp; Travels
            </h2>
            <p className="text-stone-600 leading-relaxed mb-6">
              Mallikarjuna Tours &amp; Travels is a trusted name in the cab
              business, with over a decade of experience serving the Hyderabad,
              Telangana region. Our specialty lies in offering exclusive cab tour
              packages from Hyderabad to the sacred destination of Srisailam, home
              to the revered Mallikarjuna Jyothirlinga. We invite you to embark on
              a spiritual and scenic adventure with us.
            </p>

            <div className="grid sm:grid-cols-2 gap-5">
              {FEATURES.map((f, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={f.title}
                    className="flex gap-4 rounded-2xl bg-white p-4 shadow-sm border border-amber-100 hover:shadow-md transition-shadow"
                  >
                    <div className="h-11 w-11 rounded-xl bg-orange-100 flex items-center justify-center shrink-0">
                      <Icon className="h-5 w-5 text-orange-700" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-stone-800 text-sm">
                        {f.title}
                      </h4>
                      <p className="text-xs text-stone-500 mt-1">{f.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
